import { apiFetch } from './api';

export interface DevEnv {
  id: string;
  projectId: string;
  ownerId: string;
  ownerName: string;
  ownerAvatarColor?: string;
  displayName: string;
  containerCode: string;
  dockerImage: string;
  pteroServerId?: number;
  pteroIdentifier?: string;
  pteroUuid?: string;
  status: 'creating' | 'installing' | 'running' | 'stopped' | 'errored';
  errorMessage?: string;
  createdAt?: string;
  lastRunAt?: string;
  /** IP:port publique du serveur Ptero (null si pas encore alloué / Ptero KO). */
  publicAddress?: string;
  /** Groupe de jeu choisi à la création (RECUBE_GROUP du serveur). Absent : défaut de l'egg. */
  group?: string;
}

export interface DevEnvCreateInput {
  displayName?: string;
  containerCode: string;
  /**
   * Clé du groupe de jeu (NationsGlory seulement), posée dans RECUBE_GROUP. Absente : défaut de
   * l'egg. 400 si l'egg des dev envs ne déclare pas la variable, ou si la clé est inconnue.
   */
  group?: string;
}

export type PowerSignal = 'start' | 'stop' | 'restart' | 'kill';

const baseUrl = (pid: string) => `/api/projects/${pid}/dev-envs`;

export const devEnvService = {
  list: (pid: string) => apiFetch<DevEnv[]>(baseUrl(pid)),
  get: (pid: string, id: string) => apiFetch<DevEnv>(`${baseUrl(pid)}/${id}`),
  create: (pid: string, input: DevEnvCreateInput) =>
    apiFetch<DevEnv>(baseUrl(pid), { method: 'POST', json: input }),
  power: (pid: string, id: string, signal: PowerSignal) =>
    apiFetch<void>(`${baseUrl(pid)}/${id}/power/${signal}`, { method: 'POST' }),
  /** Modifie manuellement l'image docker de l'env (snapshot, ne suit pas
   *  container.containerVersion). Push aussi vers Ptero si serveur existe. */
  updateImage: (pid: string, id: string, dockerImage: string) =>
    apiFetch<DevEnv>(`${baseUrl(pid)}/${id}/image`, {
      method: 'PATCH', json: { dockerImage },
    }),
  remove: (pid: string, id: string) =>
    apiFetch<void>(`${baseUrl(pid)}/${id}`, { method: 'DELETE' }),
};
